import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { ReportesRentabilidadController } from './reportes-rentabilidad.controller';
import { ReportesRentabilidadService } from './reportes-rentabilidad.service';

@Module({
  imports: [PrismaModule],
  controllers: [ReportesRentabilidadController],
  providers: [ReportesRentabilidadService],
})
export class ReportesRentabilidadModule {}
